import { Typography } from '@mui/material'
import React from 'react'
import { RowBetweenX } from '@/components/common/Rows'
import useActivityState, { ActivityState } from '@/hooks/useActivityState'

const Countdown = ({
  startAt,
  endAt,
  onStateChange,
}: {
  startAt: number
  endAt: number
  onStateChange: (state: ActivityState) => void
}) => {
  const titleMap: Record<ActivityState, string> = {
    upcoming: 'Starts in',
    on_going: 'Ends in',
    ended: 'Ended',
  }

  const { activityState: poolStatus, formattedRes } = useActivityState({
    startAt,
    endAt,
    onStart: () => {
      onStateChange('on_going')
    },
    onEnd: () => {
      onStateChange('ended')
    },
  })

  const { days, hours, minutes, seconds } = formattedRes || {}

  return (
    <RowBetweenX>
      <Typography sx={{ fontSize: '14px', fontWeight: 400, opacity: 0.7 }}>{titleMap[poolStatus]}</Typography>
      {formattedRes && (
        <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
          {days} d {hours} h {minutes} m {seconds} s
        </Typography>
      )}
    </RowBetweenX>
  )
}

export default Countdown
